"use client"

import Checkbox, { type CheckboxProps } from "~/components/ui/Checkbox"
import { useTranslate } from "~/providers/I18nProvider/hooks/useTranslate"

import * as css from "../styles.css"

export function StandardCheckbox({
  type,
  name,
  value,
  asDictionaryKey,
  ...props
}: CheckboxProps & { asDictionaryKey?: boolean }) {
  const t = useTranslate()

  if (!value || typeof value !== "string" || !name) return null

  return (
    <Checkbox
      {...props}
      type={type ?? "checkbox"}
      checkmarkActive={null}
      contentClassName={css.checkbox}
      checkmarkActiveClassName={css.checkmarkActive}
      name={name}
      value={value}
      id={value}
    >
      {asDictionaryKey ? t(value) : value}
    </Checkbox>
  )
}
